import { createReducer, on } from '@ngrx/store';
import { IScoreState } from 'src/app/model/interface/IScoreState';
import { addScoreItem } from '../actions/score.actions';

export const initialState: IScoreState = {
  scoreItems: [],
  finishedTest: false,
};

export const scoreReducers = createReducer(
  initialState,
  on(addScoreItem, (state, { scoreItems }) => {
    return { ...state, scoreItems };
  })
);
